import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Field, FieldArray, useFormikContext } from 'formik';

import { ReactComponent as AddButton } from '../../../../../assets/images/AddButton.svg';
import { ReactComponent as CrossIcon } from '../../../../../assets/images/CrossIcon.svg';
import { ReactComponent as WebsiteFormIcon } from '../../../../../assets/images/WebsiteFormIcon.svg';
import CustomTextField from '../../../../../components/shared/CustomTextField/CustomTextField';
import { filterData } from '../../../../../helpers/commonHelper';
import { IsMobile } from '../../../../../helpers/IsMobile';

import styles from '../AddContactModal.module.scss';

const ContactFormWebsites = ({ isEdit }) => {
  const { t } = useTranslation('common');
  const { values, setValues } = useFormikContext();
  const isMobile = IsMobile();

  const lastElement = useMemo(() => {
    const filteredData = filterData(values.user_contact_websites_attributes);
    return filteredData[filteredData.length - 1];
  }, [values]);

  const handleRemoveField = useCallback(
    (arrayHelpers, index) => {
      if (values.user_contact_websites_attributes.length === 1) {
        arrayHelpers.replace(index, { website: '' });
      } else {
        arrayHelpers.remove(index);
      }
    },
    [values]
  );

  const handleEditRemoveField = useCallback(
    (arrayHelpers, index) => {
      const newData = [...values.user_contact_websites_attributes];
      if (newData[index].id) {
        newData[index] = { ...newData[index], _destroy: true };
        setValues({ ...values, user_contact_websites_attributes: newData });
      }
      const data = filterData(newData);
      if (data.length === 0) {
        arrayHelpers.insert(index + 1, { website: '' });
      }
      if (!newData[index].id) {
        if (data.length === 1) {
          arrayHelpers.replace(index, { website: '' });
        } else {
          arrayHelpers.remove(index);
        }
      }
    },
    [values]
  );

  return (
    <div>
      <FieldArray
        name="user_contact_websites_attributes"
        render={(arrayHelpers) => (
          <div className={styles.container}>
            {values.user_contact_websites_attributes?.map((value, index) => {
              const { _destroy } = value;
              if (!_destroy) {
                return (
                  <div className={styles.multiInputWrapper}>
                    <div className={isMobile ? styles.multiInputFieldMobile : styles.inputField}>
                      <Field
                        name={`user_contact_websites_attributes[${index}].website`}
                        as={CustomTextField}
                        value={value.website}
                        type="text"
                        label={t('contactModal.websites')}
                        className={styles.inputField}
                        CustomIcon={WebsiteFormIcon}
                      />
                    </div>
                    {isMobile ? (
                      <div>
                        {value.website.length > 0 && (
                          <div className={value.website.length > 0 && styles.mobileIconButtons}>
                            <button
                              type="button"
                              onClick={() => handleRemoveField(arrayHelpers, index)}
                              className={styles.iconButton}
                            >
                              <CrossIcon />
                            </button>
                            {value.website.length > 0 &&
                              lastElement === values.user_contact_websites_attributes[index] && (
                                <button
                                  className={styles.iconButton}
                                  type="button"
                                  onClick={() => arrayHelpers.insert(index + 1, { website: '' })}
                                >
                                  <AddButton />
                                </button>
                              )}
                          </div>
                        )}
                      </div>
                    ) : (
                      <div
                        className={
                          value.website?.length > 0 ? styles.showIconButtonContainer : styles.iconButtonContainer
                        }
                      >
                        <button
                          type="button"
                          onClick={() =>
                            isEdit ? handleEditRemoveField(arrayHelpers, index) : handleRemoveField(arrayHelpers, index)
                          }
                          className={styles.iconButton}
                        >
                          <CrossIcon />
                        </button>
                        {value.website?.length > 0 &&
                          lastElement === values.user_contact_websites_attributes[index] && (
                            <button
                              className={styles.iconButton}
                              type="button"
                              onClick={() => arrayHelpers.insert(index + 1, { website: '' })}
                            >
                              <AddButton />
                            </button>
                          )}
                      </div>
                    )}
                  </div>
                );
              }
            })}
          </div>
        )}
      />
    </div>
  );
};

export default ContactFormWebsites;
